export default "__VITE_ASSET__BqoqTS4I__"